import { format } from 'date-fns';

export function dateToDateOnlyString(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}
